<template>
  <div>
    <v-container fill-height fluid grid-list-xl class="pl-3 pt-0">
      <v-layout wrap>
        <v-flex>
          <div
            class="pa-1"
            v-if="request && request.id"
            style="position: sticky; top: 0px; z-index: 10; background-color: #e4ede6;"
          >
            <v-tabs v-model="activeTab" class="ticket-tabs">
              <v-tab :class="activeTab === 0 ? 'tab-active' : ''">
                View Ticket
              </v-tab>
              <v-tab :class="activeTab === 1 ? 'tab-active' : ''">
                Edit Ticket
              </v-tab>
              <v-tab :class="activeTab === 2 ? 'tab-active' : ''">
                View User
              </v-tab>
              <v-tab :class="activeTab === 3 ? 'tab-active' : ''">
                Resolution
              </v-tab>
              <v-tab :class="activeTab === 4 ? 'tab-active' : ''">
                Logs
              </v-tab>
            </v-tabs>
            <div
              style="display: flex; justify-content: space-between; align-items: center;"
              class="py-0"
            >
              <div
                class="ml-2"
                style="display: flex; align-items: center; gap: 8px; flex-wrap: wrap;"
              >
                <router-link
                  :to="{ name: 'HelpDeskTechnicianRequests' }"
                  style="text-decoration: none; color: #2e7d32; font-weight: 600; font-size: 14px;"
                  >All Support Requests</router-link
                >
                <span style="color: #9e9e9e;">/</span>
                <span
                  v-html="request.subject"
                  style="font-size: 20px; font-weight: 700; color: #212121;"
                ></span>
                <a
                  v-if="isTechnician()"
                  :href="
                    `https://utaw.sdpondemand.manageengine.com/app/itdesk/ui/requests/${
                      request.manageengineID
                    }/details`
                  "
                  target="_blank"
                  style="text-decoration: none;"
                >
                  <span
                    style="
                background-color: #e8f5e9;
                color: #2e7d32;
                border: 1px solid #a5d6a7;
                border-radius: 6px;
                padding: 2px 8px;
                font-size: 13px;
                font-weight: 600;
                white-space: nowrap;
                display: inline-flex;
                align-items: center;
                gap: 3px;
              "
                    >{{ "#" + request.displayID
                    }}<v-icon small color="green" style="font-size: 13px;"
                      >mdi-open-in-new</v-icon
                    ></span
                  >
                </a>
                <span
                  v-else
                  style="
                background-color: #f5f5f5;
                color: #424242;
                border: 1px solid #e0e0e0;
                border-radius: 6px;
                padding: 2px 8px;
                font-size: 13px;
                font-weight: 600;
                white-space: nowrap;
              "
                  >{{ "#" + request.displayID }}</span
                >
              </div>

              <div
                class=" pb-1 pt-2"
                style="display: flex; align-items: center; flex-wrap: wrap; gap: 8px;"
              >
                <v-btn
                  small
                  flat
                  class="ticket-header-nav"
                  :disabled="!hasPrevTicket || loading"
                  @click="goToPrevTicket"
                  title="Previous"
                >
                  &lt;
                </v-btn>
                <v-btn
                  small
                  flat
                  class="ticket-header-nav"
                  :disabled="!hasNextTicket || loading"
                  @click="goToNextTicket"
                  title="Next"
                >
                  &gt;
                </v-btn>
              </div>
            </div>
          </div>

          <v-tabs-items v-model="activeTab">
            <v-tab-item>
              <v-layout row wrap>
                <v-flex xs9>
                  <v-card style="border: 2px solid rgb(76, 175, 80);">
                    <div v-if="loading" class="px-3 mt-2 py-2">
                      <v-progress-linear
                        :indeterminate="true"
                        color="success"
                      ></v-progress-linear>
                    </div>

                    <v-layout
                      row
                      align-center
                      class="px-3"
                      v-if="request && request.id"
                    >
                      <v-card-text>
                        <div
                          class="body-1 font-weight-light d-flex align-center"
                          style="flex-wrap: wrap; justify-content: space-between;"
                        >
                          <div
                            style="flex: 1 1 auto; min-width: 0; margin-right: 8px;"
                          >
                            Requested By:
                            <span class="font-weight-medium">
                              <a @click="searchUserTickets">{{
                                request.requesterName
                              }}</a>
                            </span>

                            On:
                            <span class="font-weight-medium">{{
                              request.createdAt | time
                            }}</span>
                            User:
                            <span class="font-weight-medium">{{
                              meUsername
                            }}</span>
                            <span v-show="request.requesterEmailID">
                              Email:
                            </span>

                            <span class="font-weight-medium">{{
                              request.requesterEmailID
                            }}</span>
                            <!-- Site:
                            <span class="font-weight-medium">{{
                              request.requestSiteName
                            }}</span> -->
                            Create via:
                            <span class="font-weight-medium"
                              >{{ request.source }}
                              {{
                                request.itReceptionBy
                                  ? `: ${request.itReceptionBy}`
                                  : ""
                              }}</span
                            >
                          </div>
                          <span class="text-xs-right" style="flex: 0 0 auto;">
                            <v-btn
                              style="border: 1px solid #e0e0e0; border-radius: 6px; padding: 2px 8px; font-size: 13px; font-weight: 600; white-space: nowrap; display: inline-flex; align-items: center; gap: 3px;"
                              :disabled="loading"
                              small
                              flat
                              class="ticket-header-nav--with-label"
                              title="Reply to the ticket"
                              @click="openReplyDialog"
                            >
                              <v-icon small>mdi-reply</v-icon>
                              Reply
                            </v-btn>

                            <v-btn
                              style="border: 1px solid #e0e0e0; border-radius: 6px; padding: 2px 8px; font-size: 13px; font-weight: 600; white-space: nowrap; display: inline-flex; align-items: center; gap: 3px;"
                              :disabled="loading"
                              small
                              flat
                              class="ticket-header-nav--with-label"
                              title="Add Note"
                              @click="addNoteDialog = true"
                            >
                              <v-icon small>mdi-note-text</v-icon>
                              Add Note
                            </v-btn>
                          </span>
                        </div>
                        <v-layout
                          row
                          justify-end
                          class="mb-2 mt-4 mr-2"
                          v-if="
                            request.description ||
                              JSON.parse(this.request.attachments).length > 0
                          "
                        >
                          <v-flex xs11>
                            <v-card
                              style="border: 2px solid rgb(243, 241, 249);  padding-top: 40px;"
                            >
                              <div
                                class="card-header"
                                style="background: rgb(243, 241, 249);"
                              >
                                <div class="ml-3">
                                  {{ request.requesterName }}
                                  -
                                  {{ request.createdTimeDisplayValue }}
                                </div>
                              </div>

                              <div
                                class="ml-3 pl-3 mr-3 pr-3 mt-4 my-3 "
                                v-html="request.description"
                              ></div>
                              <v-divider class="mt-3"></v-divider>
                              <div
                                class="subheading font-weight-light ml-3 mt-3 mb-1"
                              >
                                {{ getAttachmentText() }}
                              </div>
                              <div class="attachments-container">
                                <div
                                  v-for="attachment in getAttachments()"
                                  :key="attachment.name"
                                  class="ml-3"
                                >
                                  <v-btn
                                    v-if="!isAudioFile(attachment.name)"
                                    class="mt-2 ml-1 px-3 button-attachment"
                                    @click="loadFile(attachment)"
                                  >
                                    <v-icon color="blue" left dark
                                      >mdi-file</v-icon
                                    >
                                    {{ truncateText(attachment.name) }}
                                    <v-icon right>mdi-open-in-new</v-icon>
                                  </v-btn>

                                  <audio v-else controls class="mt-2 ml-1">
                                    <source
                                      :src="getAudioSrc(attachment)"
                                      type="audio/mpeg"
                                    />
                                  </audio>
                                </div>
                              </div>
                            </v-card>
                          </v-flex>
                        </v-layout>
                        <v-layout
                          v-show="!request.description"
                          class="mt-3 mb-3"
                        ></v-layout>

                        <v-layout
                          row
                          justify-end
                          class="mr-2"
                          v-if="
                            this.loadAllConversationsBtn ||
                              this.showConversationBtn
                          "
                        >
                          <v-flex xs11>
                            <v-card
                              style="border: 3px solid rgb(211, 219, 218); padding-top: 33px;"
                            >
                              <button
                                class="card-header"
                                style="background: rgb(211, 219, 218); text-align: left;"
                                :disabled="loadingConversations"
                                @click="clickConversationBtn()"
                              >
                                <div
                                  v-show="
                                    !loadingConversations && showConversationBtn
                                  "
                                  style="text-align: center;"
                                >
                                  Click here to Show all conversations
                                </div>
                                <div
                                  v-show="loadingConversations"
                                  style="text-align: center;"
                                >
                                  loading conversations...
                                </div>
                                <div
                                  v-show="loadAllConversationsBtn"
                                  style="text-align: center;"
                                >
                                  Click on conversation or click here to expand
                                  all conversations
                                </div>
                              </button>
                            </v-card>
                          </v-flex>
                        </v-layout>
                        <v-layout
                          row
                          justify-end
                          class="mr-2"
                          v-for="(conversation, index) in conversationList"
                        >
                          <v-flex xs11>
                            <v-card
                              :style="
                                `border: 3px solid rgb(${
                                  conversation.type === 'CONVERSATION'
                                    ? '255, 229, 229'
                                    : conversation.type === 'NOTES'
                                    ? '250, 228, 163'
                                    : '217, 255, 235'
                                }); bposition: relative; padding-top: 33px;`
                              "
                            >
                              <button
                                class="card-header"
                                :disabled="conversation.load"
                                :style="
                                  `background: rgb(${
                                    conversation.type === 'CONVERSATION'
                                      ? '255, 229, 229'
                                      : conversation.type === 'NOTES'
                                      ? '250, 228, 163'
                                      : '217, 255, 235'
                                  }); text-align: left;`
                                "
                                @click="expandConversation(index)"
                              >
                                <div
                                  class="ml-3"
                                  style="display: flex; align-items: center; width: 100%;"
                                >
                                  <div>
                                    {{
                                      conversation.senderName != "UserPortal"
                                        ? conversation.senderName + " - "
                                        : ""
                                    }}

                                    {{ conversation.timeDisplayValue }}
                                    <span v-if="conversation.hasAttachments">
                                      -
                                      <v-icon>mdi-attachment</v-icon>
                                    </span>
                                  </div>
                                  <span
                                    style="margin-left: auto; margin-right: 50%;"
                                    v-show="
                                      !conversation.expanded &&
                                        !conversation.load
                                    "
                                  >
                                    <v-icon small>mdi-arrow-expand</v-icon>
                                  </span>
                                  <span
                                    style="margin-left: auto; margin-right: 50%;"
                                    v-show="conversation.load"
                                  >
                                    load...
                                  </span>
                                </div>
                              </button>

                              <div
                                v-show="conversation.expanded"
                                class="ml-0 mt-4 pl-3 my-3"
                              >
                                <h6
                                  class="font-weight-bold"
                                  v-html="conversation.subject"
                                ></h6>
                                <p class="mt-2" v-if="conversation.sendTo">
                                  <b>To:</b>
                                  {{ getSendCTo(conversation.sendTo) }}
                                </p>
                                <v-divider class="mt-3 mb-3"></v-divider>
                                <p v-html="conversation.description"></p>
                                <v-divider
                                  v-if="conversation.attachments"
                                  class="mt-3"
                                ></v-divider>
                                <div
                                  v-if="conversation.attachments"
                                  class="subheading font-weight-light ml-3 mt-3 mb-1"
                                >
                                  {{
                                    getConversationAttachmentCount(
                                      conversation.attachments
                                    )
                                  }}
                                </div>
                                <div
                                  class="attachments-container"
                                  v-if="conversation.attachments"
                                >
                                  <div
                                    v-for="attachment in getConversationAttachments(
                                      conversation.attachments
                                    )"
                                    :key="attachment.name"
                                    class="ml-3"
                                  >
                                    <v-btn
                                      v-if="!isAudioFile(attachment.name)"
                                      class="mt-2 ml-1 px-3 button-attachment"
                                      @click="loadFile(attachment)"
                                    >
                                      <v-icon color="blue" left dark
                                        >mdi-file</v-icon
                                      >
                                      {{ truncateText(attachment.name) }}
                                      <v-icon right>mdi-open-in-new</v-icon>
                                    </v-btn>

                                    <audio v-else controls class="mt-2 ml-1">
                                      <source
                                        :src="getAudioSrc(attachment)"
                                        type="audio/mpeg"
                                      />
                                    </audio>
                                  </div>
                                </div>
                              </div>
                            </v-card>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-layout> </v-card
                ></v-flex>
                <v-flex xs3>
                  <v-card style="border: 2px solid rgb(76, 175, 80);">
                    <div v-if="loading" class="px-3 mt-2 py-2">
                      <v-progress-linear
                        :indeterminate="true"
                        color="success"
                      ></v-progress-linear>
                    </div>
                    <v-card-text v-if="request && request.id">
                      <div
                        class="mt-0 ml-3 my-2 body-1 font-weight-light"
                        style="position: relative;"
                      >
                        <v-icon
                          dark
                          style="position: absolute; top: 0px; right: 0px; font-size: 50px; z-index: 1;"
                          :color="getStatusIconColor()"
                          >{{ getStatusIcon() }}</v-icon
                        >
                        <v-layout row class="mb-3">
                          <span class="font-weight-light mr-2">
                            ManageEngine ID:
                          </span>
                          <span class="font-weight-medium">
                            {{ request.manageengineID }}
                          </span>
                        </v-layout>
                        <v-layout row class="mb-3">
                          <span class="font-weight-light mr-2">
                            Ticket Number:
                          </span>
                          <span class="font-weight-medium">
                            {{request.displayID }}
                          </span>
                        </v-layout>
                        <v-layout row align-center class="mb-3">
                          <span
                            class="font-weight-light mr-2"
                            style="flex: 0 0 auto;"
                          >
                            Status:
                          </span>
                          <v-flex
                            shrink
                            class="pa-0 ma-0"
                            style="min-width: 0;"
                          >
                            <span
                              v-if="!showStatusDropdown"
                              class="font-weight-medium"
                              @click="
                                (showStatusDropdown = true),
                                  (statusPointer = false)
                              "
                              @mouseover="statusPointer = true"
                              @mouseleave="statusPointer = false"
                              style="cursor: pointer;"
                            >
                              {{ request.statusName }}
                              <v-icon v-if="statusPointer" small class="ml-1"
                                >mdi-pencil</v-icon
                              >
                            </span>
                            <v-select
                              v-else
                              v-model="selectedStatus"
                              :items="['Open', 'Closed', 'On Hold']"
                              item-text="text"
                              item-value="value"
                              dense
                              hide-details
                              class="font-weight-medium ma-0 pt-0"
                              style="max-width: 100px;"
                              @change="onStatusChange"
                              @blur="showStatusDropdown = false"
                              autofocus
                            ></v-select>
                          </v-flex>
                        </v-layout>

                        <v-layout row align-center class="mb-3">
                          <span
                            class="font-weight-light mr-2"
                            style="flex: 0 0 auto;"
                          >
                            Technician:
                          </span>
                          <v-flex
                            shrink
                            class="pa-0 ma-0"
                            style="min-width: 0;"
                          >
                            <span
                              v-if="!showTechnicianDropdown"
                              class="font-weight-medium"
                              @click="
                                (showTechnicianDropdown = true),
                                  (technicianPointer = false),
                                  getTechnicians()
                              "
                              @mouseover="technicianPointer = true"
                              @mouseleave="technicianPointer = false"
                              style="cursor: pointer;"
                            >
                              {{ request.technicianName || "Not assigned" }}
                              <v-icon
                                v-if="technicianPointer"
                                small
                                class="ml-1"
                                >mdi-pencil</v-icon
                              >
                            </span>
                            <v-autocomplete
                              v-else
                              v-model="selectedTechnician"
                              :items="
                                technicians.length > 0
                                  ? technicians.map((t) => t.name)
                                  : [request.technicianName]
                              "
                              placeholder="Select Technician"
                              dense
                              hide-details
                              clearable
                              class="font-weight-medium ma-0 pt-0"
                              style="max-width: 220px;"
                              @change="onTechnicianChange"
                              @blur="showTechnicianDropdown = false"
                              autofocus
                            ></v-autocomplete>
                          </v-flex>
                        </v-layout>
                        <v-layout row align-center class="mb-3">
                          <span
                            class="font-weight-light mr-2"
                            style="flex: 0 0 auto;"
                          >
                            Category:
                          </span>
                          <v-flex
                            shrink
                            class="pa-0 ma-0"
                            style="min-width: 0;"
                          >
                            <span
                              v-if="!showCategoryDropdown"
                              class="font-weight-medium"
                              @click="
                                (showCategoryDropdown = true),
                                  (categoryPointer = false),
                                  getCategories()
                              "
                              @mouseover="categoryPointer = true"
                              @mouseleave="categoryPointer = false"
                              style="cursor: pointer;"
                            >
                              {{ request.categoryName }}
                              <v-icon v-if="categoryPointer" small class="ml-1"
                                >mdi-pencil</v-icon
                              >
                            </span>
                            <v-autocomplete
                              v-else
                              v-model="selectedCategory"
                              :items="
                                categories.length > 0
                                  ? categories.map((c) => c.name)
                                  : [request.categoryName]
                              "
                              placeholder="Select Category"
                              dense
                              hide-details
                              class="font-weight-medium ma-0 pt-0"
                              style="max-width: 220px;"
                              @change="onCategoryChange"
                              @blur="showCategoryDropdown = false"
                              autofocus
                            ></v-autocomplete>
                          </v-flex>
                        </v-layout>

                        <v-layout row align-center class="mb-3">
                          <span
                            class="font-weight-light mr-2"
                            style="flex: 0 0 auto;"
                          >
                            Priority:
                          </span>
                          <v-flex
                            shrink
                            class="pa-0 ma-0"
                            style="min-width: 0;"
                          >
                            <span
                              v-if="!showPriorityDropdown"
                              class="font-weight-medium"
                              @click="
                                (showPriorityDropdown = true),
                                  (priorityPointer = false)
                              "
                              @mouseover="priorityPointer = true"
                              @mouseleave="priorityPointer = false"
                              style="cursor: pointer;"
                            >
                              <v-icon
                                id="PriorityColor"
                                small
                                :color="getPriority().color"
                                >mdi-box-shadow</v-icon
                              >
                              {{ getPriority().text }}
                              <v-icon v-if="priorityPointer" small class="ml-1"
                                >mdi-pencil</v-icon
                              >
                            </span>
                            <v-autocomplete
                              v-else
                              v-model="selectedPriority"
                              :items="priorityOptions.map((p) => p.text)"
                              placeholder="Select Priority"
                              dense
                              hide-details
                              class="font-weight-medium ma-0 pt-0"
                              style="max-width: 220px;"
                              @change="onPriorityChange"
                              @blur="showPriorityDropdown = false"
                              autofocus
                            ></v-autocomplete>
                          </v-flex>
                        </v-layout>
                        <v-layout row align-center class="mb-3">
                          <span
                            class="font-weight-light mr-2"
                            style="flex: 0 0 auto;"
                          >
                            Site:
                          </span>
                          <v-flex
                            shrink
                            class="pa-0 ma-0"
                            style="min-width: 0;"
                          >
                            <span class="font-weight-medium">

                              {{ request.requestSiteName }}

                            </span>
                          </v-flex>
                        </v-layout>

                        <v-layout row class="mb-3">
                          <span class="font-weight-light mr-2">
                            ETA:
                          </span>

                          <span class="font-weight-medium">
                            {{ getETA() }}
                          </span>
                        </v-layout>
                        <b class="mt-2 ml-0 pr-0" v-html="getClosedInfo()"></b>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-tab-item>

            <v-tab-item>
              <v-flex xs8 class="pa-0">
                <HelpDeskTechnicianRequestEdit
                  v-if="activeEdit"
                  :initialData="request"
                  @updated="updated"
                  @cancel="activeTab = 0"
                />
              </v-flex>
            </v-tab-item>
            <v-tab-item>
              <v-layout row wrap v-if="activeUserView">
                <v-flex
                  xs4
                  v-for="_requester in requester"
                  :key="_requester.id"
                >
                  <ManageengineUserView
                    :initial-data="{ user: _requester, fromTicketTab: true }"
                    @saveChanges="reloadData"
                  />
                </v-flex>
              </v-layout>
            </v-tab-item>

            <v-tab-item>
              <v-layout row wrap v-if="activeResolution">
                <v-flex xs4>
                  <Resolution
                    :initial-data="{ ticket: request }"
                    @updated="updated"
                  />
                </v-flex>
              </v-layout>
            </v-tab-item>
            <v-tab-item>
              <v-layout row wrap v-if="activeLogs">
                <v-flex xs6>
                  <Logs :initial-data="{ ticket: request.displayID }" />
                </v-flex>
              </v-layout>
            </v-tab-item>
          </v-tabs-items>
        </v-flex>
      </v-layout>
    </v-container>
    <close-ticket-dialog
      v-if="request && request.id"
      v-model="closeTicketDialog"
      :initial-data="{ request: request, technician: true }"
      @tickedClosed="loadRequest()"
    />
    <v-dialog v-model="addNoteDialog" persistent max-width="800">
      <v-card>
        <v-card-title>
          <span class="headline">Add Note</span>
          <span class="ml-3">Not visible for the users. </span>
        </v-card-title>
        <v-form ref="form">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-Textarea
                  v-model="addNoteDescription"
                  label="Write a Note"
                  outline
                  ref="addNote"
                ></v-Textarea>
              </v-flex>
            </v-layout>
          </v-container>

          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>

            <v-btn
              color="default"
              @click="(addNoteDialog = false), (addNoteDescription = '')"
              dark
              small
              >Cancel</v-btn
            >
            <v-btn
              :loading="processing"
              color="success"
              @click="addNote"
              :disabled="!addNoteDescription"
              small
              >Send</v-btn
            >
            <!-- <input type="file" multiple style="display: none" ref="files" @change="onFilePicked($event)" /> -->
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="replyDialog" persistent max-width="800">
      <v-card>
        <v-card-title>
          <span class="headline">Reply</span>
        </v-card-title>
        <v-form ref="form">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <div
                  contenteditable="true"
                  ref="reply"
                  class="reply-editor"
                  v-html="replyTemplate"
                  @input="updateReplyDescription"
                ></div>
              </v-flex>
            </v-layout>
          </v-container>

          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>

            <v-btn color="default" @click="replyDialog = false" dark small
              >Cancel</v-btn
            >
            <v-btn
              :loading="processing"
              color="success"
              @click="technicianReply"
              small
              >Send</v-btn
            >
            <!-- <input type="file" multiple style="display: none" ref="files" @change="onFilePicked($event)" /> -->
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <UserTicketsDialog
      v-if="SearchUserTickets"
      :initial-data="{
        manageengineUser: requester.find(
          (r) => r.id === this.request.requesterID
        ),
      }"
      @closed="SearchUserTickets = false"
    />
  </div>
</template>
<script>
import { formatPhoneNumber, truncate, pluralize } from "../../utils/helpers.js";
import CloseTicketDialog from "./CloseTicketDialog.vue";
import {
  getETA,
  loadFile,
  isTechnician,
  getStatusIcon,
  getStatusIconColor,
  getClosedInfo,
  isAudioFile,
  getAudioSrc,
  getTechnician,
  linkifyPlainUrlsInHtml,
  priorityOptions,
} from "./helpDeskHelpers.js";
import UserTicketsDialog from "./UserTicketsDialog.vue";
import HelpDeskTechnicianRequestEdit from "./HelpDeskTechnicianRequestEdit.vue";
import ManageengineUserView from "./ManageengineUserView.vue";
import Resolution from "./Resolution.vue";
import Logs from "./Logs.vue";
export default {
  metaInfo() {
    return {
      title: `Support Ticket #${this.$route.params.id} | Technician`,
    };
  },
  components: {
    CloseTicketDialog,
    UserTicketsDialog,
    HelpDeskTechnicianRequestEdit,
    ManageengineUserView,
    Resolution,
    Logs,
  },
  data: () => ({
    statusPointer: false,
    activeTab: 0,
    loading: false,
    request: null,
    requester: null,
    SearchUserTickets: false,
    showConversationBtn: false,
    loadingConversations: false,
    loadAllConversationsBtn: false,
    conversationList: null,
    conversationAttachments: null,
    processing: false,
    reopenProcessing: false,
    loading: true,
    closeTicketDialog: false,
    meUsername: null,
    addNoteDialog: false,
    addNoteDescription: "",
    replyDialog: false,
    replyDescription: "",
    replyTemplate: "",
    regID: "",
    selectedStatus: "",
    showStatusDropdown: false,
    technicians: [],
    selectedTechnician: null,
    showTechnicianDropdown: false,
    technicianPointer: false,
    categories: [],
    selectedCategory: null,
    showCategoryDropdown: false,
    categoryPointer: false,
    priorityOptions: priorityOptions,
    selectedPriority: null,
    showPriorityDropdown: false,
    priorityPointer: false,
    activeEdit: false,
    activeUserView: false,
    activeResolution: false,
    activeLogs: false,
    // pagination: {
    //   totalCount: 0,
    //   rowsPerPage: 5,
    //   page: 1,
    // },
  }),

  computed: {
    ticketIds() {
      const query = this.$route.query || {};
      const numericKeys = Object.keys(query)
        .filter((k) => !isNaN(k))
        .sort((a, b) => Number(a) - Number(b));
      return numericKeys.map((k) => query[k]);
    },
    currentTicketIndex() {
      if (!this.$route.params || !this.$route.params.id) return -1;
      return this.ticketIds.indexOf(this.$route.params.id);
    },
    hasPrevTicket() {
      return this.currentTicketIndex > 0;
    },
    hasNextTicket() {
      return (
        this.currentTicketIndex > -1 &&
        this.currentTicketIndex < this.ticketIds.length - 1
      );
    },
  },

  watch: {
    "$route.params.id": {
      immediate: false,
      async handler() {
        this.loading = true;
        await this.load();
      },
    },
    activeTab: {
      immediate: true,
      handler(val) {
        this.activeEdit = val === 1;
        this.activeUserView = val === 2;
        this.activeResolution = val === 3;
        this.activeLogs = val === 4;
      },
    },
  },

  async created() {
    await this.load();
  },
  methods: {
    async getManageengineUserInfo() {
      try {
        const response = await this.$http.get(
          `api/manageengineUSers/getManageengineUserInfo?id=${
            this.request.requesterID
          }`
        );
        this.requester = response.data;
      } catch (error) {
        console.error(error);
      }
    },
    goToOffset(offset) {
      const ids = this.ticketIds;
      if (!ids || ids.length === 0) return;
      const currentIndex = this.currentTicketIndex;
      if (currentIndex === -1) return;
      const nextIndex = currentIndex + offset;
      if (nextIndex < 0 || nextIndex >= ids.length) return;
      const nextId = ids[nextIndex];
      this.$router.push({
        name: this.$route.name,
        params: { ...this.$route.params, id: nextId },
        query: this.$route.query,
      });
    },
    goToPrevTicket() {
      this.clearConversations();
      this.goToOffset(-1);
      this.activeTab = 0;
    },
    goToNextTicket() {
      this.clearConversations();
      this.goToOffset(1);
      this.activeTab = 0;
    },
    clearConversations() {
      this.showConversationBtn = false;
      this.loadingConversations = false;
      this.loadAllConversationsBtn = false;
      this.conversationList = null;
      this.conversationAttachments = null;
    },
    searchUserTickets() {
      this.SearchUserTickets = true;
    },
    async load() {
      await this.loadRequest();
      this.selectedStatus = this.request.statusName;
      await this.getManageengineUserInfo();
    },
    async loadRequest() {
      try {
        const response = await this.$http.get(
          `api/manageengine/getRequestbyID?id=${this.$route.params.id}`
        );

        if (response.notFound) {
          this.$notify({
            text:
              "Ticket not found – it was probably deleted or merged with another request.",
            group: "notification",
            type: "error",
          });
          setTimeout(() => {
            this.$router.push("/helpdesk/technician/requests");
          }, "500");
          return;
        }
        this.request = response.request;
        this.selectedTechnician = this.request.technicianName || null;
        this.selectedCategory = this.request.categoryName || null;
        this.selectedPriority =
          this.priorityOptions.find(
            (p) => p.name === this.request.priorityName
          ).text || null;
        this.meUsername = response.username;
        this.loading = false;
        if (
          response.request.notificationStatus != null ||
          response.request.hasNotes == true
        ) {
          this.showConversationBtn = true;
        }
      } catch (e) {
        setTimeout(() => {
          this.$router.push("/helpdesk/technician/requests");
        }, "500");
      }
    },

    isTechnician() {
      return isTechnician();
    },

    formatPhoneNumber(number) {
      return formatPhoneNumber(number);
    },
    getStatusIcon() {
      return getStatusIcon(this.request);
    },

    getStatusIconColor() {
      return getStatusIconColor(this.request);
    },

    getClosedInfo() {
      return getClosedInfo(this.request);
    },

    getAttachmentText() {
      const getAttachments = this.getAttachments();
      if (!getAttachments || getAttachments.length == 0) {
        return;
      }
      return (
        getAttachments.length +
        " " +
        pluralize("Attachment", getAttachments.length)
      );
    },
    getAttachments() {
      if (!this.request || !this.request.attachments) return [];
      return JSON.parse(this.request.attachments);
    },

    getTechnician() {
      return getTechnician(this.request);
    },
    // downloadAttachment(attachment) {
    //     window.location = attachment;
    // },
    truncateText(attachment) {
      return truncate(attachment, 30);
    },
    loadFile(file) {
      loadFile(file);
    },

    isAudioFile(fileName) {
      return isAudioFile(fileName);
    },

    getAudioSrc(file) {
      return getAudioSrc(file);
    },

    getPriority() {
      return priorityOptions.find((p) => p.id === this.request.priorityID);
    },

    getETA() {
      return getETA(this.request);
    },

    clickConversationBtn() {
      if (!this.loadAllConversationsBtn) {
        this.getConversations();
      } else {
        this.expandAllConversations();
      }
    },

    async getConversations() {
      this.loadingConversations = true;
      this.loading = true;
      const conversations = await this.$http.get(
        `api/manageengine/GetConversationsByTicket?manageengineID=${
          this.request.manageengineID
        }&requestID=${this.request.id}&isTechMode=true`
      );
      this.loading = false;
      this.loadingConversations = false;
      this.showConversationBtn = false;
      this.loadAllConversationsBtn = true;
      this.conversationList = conversations.map((c) => ({
        ...c,
        expanded: false,
        load: false,
      }));
    },

    async expandConversation(i) {
      if (this.conversationList[i].expanded) {
        this.conversationList[i].expanded = false;
        this.$set(this.conversationList, i, this.conversationList[i]);
        return;
      }
      this.conversationList[i].load = true;

      if (this.conversationList[i].type == "NOTES") {
        try {
          const response = await this.$http.get(
            `api/manageengine/GetNote?manageengineID=${
              this.conversationList[i].manageengineRequestID
            }&noteID=${this.conversationList[i].conversationID}`
          );
          this.conversationList[i].load = false;
          this.$set(this.conversationList, i, response);
        } catch {}
      } else {
        try {
          const response = await this.$http.get(
            `api/manageengine/GetConversation?manageengineID=${
              this.conversationList[i].manageengineRequestID
            }&conversationID=${this.conversationList[i].conversationID}`
          );
          this.conversationList[i].load = false;
          this.$set(this.conversationList, i, response);
        } catch {}
      }
      this.conversationList[i].expanded = true;
    },

    async expandAllConversations() {
      this.conversationList.map((c) => (c.load = true));
      this.loadAllConversationsBtn = false;
      for (var i = 0; i < this.conversationList.length; i++) {
        if (this.conversationList[i].type == "NOTES") {
          try {
            const response = await this.$http.get(
              `api/manageengine/GetNote?manageengineID=${
                this.conversationList[i].manageengineRequestID
              }&noteID=${this.conversationList[i].conversationID}`
            );
            this.conversationList[i].load = false;
            this.$set(this.conversationList, i, response);
            this.conversationList[i].expanded = true;
          } catch {}
        } else {
          try {
            const response = await this.$http.get(
              `api/manageengine/GetConversation?manageengineID=${
                this.conversationList[i].manageengineRequestID
              }&conversationID=${this.conversationList[i].conversationID}`
            );
            this.conversationList[i].load = false;
            this.$set(this.conversationList, i, response);
            this.conversationList[i].expanded = true;
          } catch {}
        }
      }
    },

    getConversationAttachments(attachments) {
      return JSON.parse(attachments);
    },
    getConversationAttachmentCount(attachments) {
      return (
        JSON.parse(attachments).length +
        " " +
        pluralize("Attachment", JSON.parse(attachments).length)
      );
    },
    getSendCTo(l) {
      return JSON.parse(l).join(", ");
    },

    async addNote() {
      try {
        this.processing = true;
        const desc = `${this.addNoteDescription}`;
        const description = linkifyPlainUrlsInHtml(
          desc.replace(/  /g, "&nbsp;").replace(/\n/g, "<br>")
        );

        const info = `<b>From: </b> ${
          this.$store.state.authentication.user
        } <hr /><br>`;

        await this.$http.post(
          `api/Manageengine/AddNote?data=${encodeURIComponent(
            info + description
          )}&manageEngineID=${this.request.manageengineID}&displayID=${
            this.request.displayID
          }`
        );

        this.$notify({
          text: "Note added successfully",
          group: "notification",
          type: "success",
        });
        this.addNoteDialog = false;
        await this.loadRequest();
        await this.getConversations();
        await this.expandConversation(this.conversationList.length - 1);
        this.processing = false;
      } catch (err) {
        console.error("Error adding note:", err);
        this.$notify({
          text: "massege not send",
          group: "notification",
          type: "error",
        });
      } finally {
        this.processing = false;
        this.addNoteDialog = false;
        this.addNoteDescription = "";
      }
    },

    async onStatusChange() {
      this.showStatusDropdown = false;
      if (this.selectedStatus == "Closed") {
        this.closeTicketDialog = true;
        return;
      }
      this.editTicket({
        StatusName: this.selectedStatus,
        ManageengineID: this.request.manageengineID,
        DisplayID: this.request.displayID,
      });
    },
    async getTechnicians() {
      if (this.technicians.length > 0) return;
      try {
        const response = await this.$http.get("odata/ManageengineTechnicians");
        this.technicians = response.value.map((m) => ({
          name: m.name,
          id: m.id,
        }));
      } catch (error) {
        console.error(error);
      }
    },

    async onTechnicianChange() {
      this.showTechnicianDropdown = false;
      const technician = this.technicians.find(
        (t) => t.name === this.selectedTechnician
      );
      const technicianId = technician ? technician.id : "clear";
      this.editTicket({
        TechnicianId: technicianId,
        ManageengineID: this.request.manageengineID,
        DisplayID: this.request.displayID,
      });
    },

    async getCategories() {
      if (this.categories.length > 0) return;
      try {
        const response = await this.$http.get("odata/ManageengineCategories");
        this.categories = response.value.map((m) => ({
          name: m.name,
          id: m.id,
        }));
      } catch (error) {
        console.error(error);
      }
    },
    async onCategoryChange() {
      this.showCategoryDropdown = false;
      const category = this.categories.find(
        (c) => c.name === this.selectedCategory
      );

      this.editTicket({
        CategoryId: category.id,
        ManageengineID: this.request.manageengineID,
        DisplayID: this.request.displayID,
      });
    },

    async onPriorityChange() {
      this.showPriorityDropdown = false;
      const priority = this.priorityOptions.find(
        (p) => p.text === this.selectedPriority
      );
      this.editTicket({
        PriorityName: priority.name,
        ManageengineID: this.request.manageengineID,
        DisplayID: this.request.displayID,
      });
    },
    async editTicket(payload) {
      try {
        await this.$http.put(`api/manageengine/editTicket`, payload);
      } catch (e) {
        console.error(e);
        return this.$notify({
          group: "notification",
          text: "Error updating ticket. Please check console for details.",
          type: "error",
        });
      }
      await this.loadRequest();
      this.$notify({
        group: "notification",
        text: "Ticked Updated",
        type: "success",
      });
    },

    async updated() {
      await this.loadRequest(), (this.activeTab = 0);
    },
    async reloadData() {
      await this.load();
      this.activeTab = 0;
    },

    defaultReplyTemplate() {
      let html = `<b>From: </b> ${this.$store.state.authentication.user
        .split("@")[0]
        .toUpperCase()}<hr />`;
      html += `Dear ${
        this.request.requesterName
      }, <hr style="border-top: 1px solid #eee; margin: 5px 0;">`;
      html += `<b>Our Reply:</b><br><br><br><br><br><br><br><hr/>`;

      html += `Technician: ${
        this.getTechnician() == "This ticket has not yet been assigned" ||
        this.getTechnician() == ""
          ? ""
          : this.getTechnician()
      }<br>`;
      html += `Category: ${
        this.request.categoryName == "" ? "" : this.request.categoryName
      }<br>`;
      //html += `Description: ${this.request.description},<br>`;
      html += `<br>Regards,<br>Our HelpDesk`;
      return html;
    },
    openReplyDialog() {
      if (this.request.requesterEmailID == null) {
        this.$notify({
          text: "User email is not available to reply to the ticket",
          group: "notification",
          type: "error",
        });
        return;
      }
      this.$refs.reply.innerHTML = this.replyTemplate = this.replyDescription = this.defaultReplyTemplate();
      this.replyDialog = true;
    },

    async technicianReply() {
      try {
        this.processing = true;
        const description = linkifyPlainUrlsInHtml(this.replyDescription);

        await this.$http.post(`api/Manageengine/Reply`, {
          DisplayID: this.request.displayID,
          ManageengineID: this.request.manageengineID,
          Subject: `Re: [Request ID :##${this.request.displayID}##] : ${
            this.request.subject
          }`,
          Description: description,
          IsFromRequester: false, // false means the reply is from the technician
          technicianName: this.request.technicianName,
          RequesterEmailID: this.request.requesterEmailID,
        });
        this.$notify({
          text: "Reply sent successfully",
          group: "notification",
          type: "success",
        });
        this.replyDialog = false;
        await this.loadRequest();
        await this.getConversations();
        await this.expandConversation(this.conversationList.length - 1);
      } catch (error) {
        console.error("Error replying to ticket:", error);
        this.$notify({
          text: "Error replying to ticket",
          group: "notification",
          type: "error",
        });
      } finally {
        this.processing = false;
        this.replyDescription = "";
        this.replyTemplate = "";
      }
    },
    updateReplyDescription(e) {
      this.replyDescription = e.target.innerHTML;
    },
  },
};
</script>
<style>
.v-expansion-panel__header {
  height: 63px;
}

.spacail-needs-link {
  color: rgb(76, 175, 80);
  display: inline-block;
  word-wrap: break-word;
  width: 100%;
}

.tip-grid.container {
  padding-left: 0px !important;
  padding-right: 0px !important;
  padding-bottom: 0px !important;
}

.tip-grid .v-card__text {
  padding-top: 4px !important;
}

.tip-grid .flex {
  padding: 0px !important;
  padding-top: 24px !important;
}

.tip-grid .v-card {
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.2), 0 0 0 0 rgba(0, 0, 0, 0.14),
    0 0 0 0 rgba(0, 0, 0, 0.12) !important;
}

.card-header {
  padding: 5px 0;
  font-weight: bold;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}

.ticket-card {
  word-wrap: break-word;
  overflow-wrap: anywhere;
  white-space: normal;
}

.button-attachment {
  max-width: 100%;
  display: block;
  margin-top: 8px;
  text-overflow: ellipsis;
}

.ticket-card audio {
  max-width: 100%;
  display: block;
  margin-top: 8px;
}

.attachments-container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}

.status-text:hover {
  opacity: 0.7;
}

.ticket-tabs {
  margin-bottom: 0;
}

.tab-active {
  background-color: rgb(76, 175, 80) !important;
  color: white !important;
  font-weight: 600 !important;
}

.ticket-header-nav {
  background-color: #e8e8e8 !important;
  border: 1px solid #d5d5d5 !important;
  color: rgb(11, 160, 16) !important;
  min-width: 36px !important;
  width: 36px !important;
  height: 36px !important;
  padding: 0 !important;
  margin: 0 !important;
  border-radius: 6px !important;
  box-shadow: none !important;
  font-size: 14px !important;
  font-weight: 600 !important;
}

.ticket-header-nav .v-btn__content {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 6px;
}

.ticket-header-nav--with-label {
  width: auto !important;
  min-width: auto !important;
  padding: 0 12px !important;
}

.reply-editor {
  border: 1px solid rgba(0, 0, 0, 0.42);
  border-radius: 4px;
  padding: 12px;
  min-height: 300px;
  font-size: 14px;
  line-height: 1.6;
  outline: none;
  overflow-y: auto;
}

.reply-editor:focus {
  border-color: #4caf50;
  border-width: 2px;
}
</style>
